import React from "react";
import {
  Navigation,
  RequiredDashboardData,
} from "@nju/feature-portal-dashboard";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { DashboardUserProfileChangeConsents } from "@nju/feature-portal-user";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function ChangeConsents() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent grid="narrow" spacing="xl" tone="gray">
        <RequiredDashboardData extendedMode="base">
          <Navigation title="mój profil" />
          <DashboardUserProfileChangeConsents />
        </RequiredDashboardData>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
